import React from 'react';
import UrlShortener from '../components/UrlShortener/UrlShortener';
import RecentLinks from '../components/Dashboard/RecentLinks';
import Features from '../components/Home/Features';
import Comparison from '../components/Home/Comparison';
import { FiShield, FiLock, FiEye } from 'react-icons/fi';

const HomePage: React.FC = () => {
  return (
    <div className="space-y-12">
      {/* Hero Section */}
      <section className="text-center py-12">
        <h1 className="text-5xl font-bold text-gray-900 mb-4">
          Shorten URLs. <span className="text-primary-600">Protect Privacy.</span>
        </h1>
        <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
          The only URL shortener that blocks trackers, anonymizes clicks, and never sells your data.
          Zero-knowledge architecture means we can't track you even if we wanted to.
        </p>
        
        {/* Trust Indicators */}
        <div className="flex justify-center space-x-8 mb-8">
          <div className="flex items-center space-x-2">
            <FiShield className="w-5 h-5 text-green-500" />
            <span className="text-sm text-gray-600">No IP Logging</span>
          </div>
          <div className="flex items-center space-x-2">
            <FiLock className="w-5 h-5 text-green-500" />
            <span className="text-sm text-gray-600">End-to-End Encryption</span>
          </div>
          <div className="flex items-center space-x-2">
            <FiEye className="w-5 h-5 text-green-500" />
            <span className="text-sm text-gray-600">Tracker Blocking</span>
          </div>
        </div>
      </section>

      {/* URL Shortener */}
      <section className="max-w-4xl mx-auto">
        <UrlShortener />
      </section>

      {/* Recent Links */}
      <section className="max-w-6xl mx-auto">
        <RecentLinks />
      </section>

      {/* Features */}
      <section id="features">
        <Features />
      </section>

      {/* Privacy Comparison */}
      <section>
        <Comparison />
      </section>
    </div>
  );
};

export default HomePage;